import { CryptoRewardsPaneMode, CryptoRewardsPaneState, CryptoRewardsPaneModeWithSteps } from 'components/features/rewards/rewardsPane/types/paneState'
import { createAction } from 'helpers/actionHelpers/createAction'
import {
  FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE,
  FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE,
  FLOATING_PANE_AUTO_INVESTMENTS_MODE,
  FLOATING_PANE_CRYPTO_REWARDS_TYPE,
} from 'components/features/rewards/rewardsPane/constants/paneState'
import { modifyFloatingPaneActionCreator } from 'actions/floatingPanesActions'
import { createRequestAction } from 'helpers/actionHelpers/createRequestAction'
import { CryptoRewardsBuyCryptoOrderSuccessResponse, CryptoRewardsSellCryptoOrderSuccessResponse } from 'components/features/rewards/rewardsPane/types/apiResponses'

export class OpenSellCryptoPaneAction extends createAction<'OPEN_SELL_CRYPTO_PANE', void>('OPEN_SELL_CRYPTO_PANE') {}

export class OpenAutoInvestmentPaneAction extends createAction<'OPEN_AUTOINVEST_PANE', void>('OPEN_AUTOINVEST_PANE') {}


export type SuccessCryptoRewardsPaneModeStepPayload<M extends CryptoRewardsPaneModeWithSteps> =
  & Omit<Required<CryptoRewardsPaneState<M>>, 'mode' | 'progressPercents' | 'progressLabel' | 'fields'>
  & {
    fields: Required<CryptoRewardsPaneState<M>['fields']>
  }

export const SUCCESS_CRYPTO_REWARDS_PANE_MODE_STEP_ACTION_TYPE = 'SUCCESS_CRYPTO_REWARDS_PANE_MODE_STEP'

function createSuccessCryptoRewardsPaneModeStepAction<M extends CryptoRewardsPaneModeWithSteps> (mode: M) {
  return class SuccessCryptoRewardsPaneModeStep extends (
    createAction<
      typeof SUCCESS_CRYPTO_REWARDS_PANE_MODE_STEP_ACTION_TYPE,
      SuccessCryptoRewardsPaneModeStepPayload<M> & Pick<CryptoRewardsPaneState<M>, 'mode'>
    >(SUCCESS_CRYPTO_REWARDS_PANE_MODE_STEP_ACTION_TYPE)
  ) {
    constructor (payload: SuccessCryptoRewardsPaneModeStepPayload<M>) {
      super({ mode, ...payload })
    }
  }
}

type BuyCryptoPayload<M extends CryptoRewardsPaneModeWithSteps> =
 & SuccessCryptoRewardsPaneModeStepPayload<M>
 & Pick<CryptoRewardsPaneState<M>, 'mode'>
export class BuyCryptoAction extends createRequestAction<'BUY_CRYPTO_REQUEST', BuyCryptoPayload<typeof FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE>, CryptoRewardsBuyCryptoOrderSuccessResponse>('BUY_CRYPTO_REQUEST') {}

export class SuccessCryptoRewardsPaneSellModeStepAction extends createSuccessCryptoRewardsPaneModeStepAction(FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE) {}

export class SellCryptoAction extends createRequestAction<'SELL_CRYPTO_REQUEST', BuyCryptoPayload<typeof FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE>, CryptoRewardsSellCryptoOrderSuccessResponse>('SELL_CRYPTO_REQUEST') {}

export class SuccessCryptoRewardsAutoInvestmentsModeStepAction extends createSuccessCryptoRewardsPaneModeStepAction(FLOATING_PANE_AUTO_INVESTMENTS_MODE) {}


export function createChangeCryptoRewardsPaneModeStepStateAction<M extends CryptoRewardsPaneMode> (mode: M) {
  return (
    updatedState: Omit<CryptoRewardsPaneState<M>, 'mode'>
  ) => modifyFloatingPaneActionCreator(
    FLOATING_PANE_CRYPTO_REWARDS_TYPE,
    {
      ...updatedState as CryptoRewardsPaneState<M>,
      mode,
    }
  )
}

export const createRewardsPaneActionChangeBuyModeStepState = createChangeCryptoRewardsPaneModeStepStateAction(FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE)
export const createRewardsPaneActionChangeSellModeStepState = createChangeCryptoRewardsPaneModeStepStateAction(FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE)
export const createRewardsPaneActionChangeAutoInvestmentsModeStepState = createChangeCryptoRewardsPaneModeStepStateAction(FLOATING_PANE_AUTO_INVESTMENTS_MODE)

export type RewardsPaneActions =
  | OpenSellCryptoPaneAction
  | OpenAutoInvestmentPaneAction
  | SuccessCryptoRewardsAutoInvestmentsModeStepAction
  | SuccessCryptoRewardsPaneSellModeStepAction
  | typeof BuyCryptoAction.Type
  | typeof SellCryptoAction.Type
